<template>
  <div>
    <!-- 头部模板 -->
    <header-yjj-m></header-yjj-m>

    <!--  内容页  -->
    <!--  轮播图  -->
<!--    <div class="slide-img" ref="slide">-->
<!--      <img id="slideImg" src="../../../assets/slide-1.jpg" ref="slideImg">-->
<!--    </div>-->

    <div class="container">
      <div style="">
        <img src="https://zbhk-new.lnyun.com.cn/www/huanren/images/202307/533633632871387345.png" style="width:100%">
      </div>

      <div class="memory-content" >

        <div class="col" v-for="item in memoryList" :key="item.index" >
          <div  >
            <div class="bg" @click="addPv(item.id,item.pv)">

                <div >
                  <img :src="item.imgsrc" style="width:100%">
                </div>
                <div style="padding:0;line-height: 20px;font-size: 12px;">
                  <p>{{ item.name }}</p>
                  <p>{{ item.pv + item.setpv }}</p>
                </div>

            </div>
          </div>

        </div>
        <!-- -->
      </div>
    </div>

    <!-- 底部模板 -->
    <footer-yjj-m></footer-yjj-m>
  </div>
</template>

<script>
import HeaderYjjM from "@/components/yjj/mobile/HeaderYjjM";
import FooterYjjM from "@/components/yjj/mobile/FooterYjjM";
import {request} from "@/request/request";

export default {
  name: "MemoryYjjM",
  components: {
    HeaderYjjM,
    FooterYjjM
  },
  data(){
    return{
      memoryList:[],
      restfulUrl:'memory',
      notcol:{}
    }
  },
  methods:{
    addPv:function(uid,upv){
      var updataPv = {
        id:uid,
        pv:upv+1
      }
      this.updateOneById(updataPv);

    },
    getData:function(){//获取全部数据
      request({
        method:'GET',
        url:this.restfulUrl,
      }).then(res =>{
        if(res.code==1){
          this.memoryList = res.data;
        }
      },err=>{
        console.log(err)
      })
    },
    updateOneById:function(data){
      request({
        method:'PUT',
        url:'/memory',
        data:data
      }).then(res =>{
        if(res.code==1){
          this.getData();
        }
      },err=>{
        console.log(err)
      })
    },
  },
  mounted() {
    this.getData();
  },
  metaInfo() {
    return {
      title: this.$route.meta.title || 'My Vue App'
    };
  }

}
</script>

<style scoped>

.container{
  min-height: 700px;
}


.slide-img{
  width:100%;
  overflow: hidden;
}
.slide-img img{
  width: 100%;
}
.memory-content{
  background: rgb(241,231,223);

  display: flex;
  padding:5px;
  text-align: center;
}
.memory-content .col{
  flex: 1;
  padding:0 2px;
}
.memory-content .col .bg{
  height:120px;
  background: white;

}
</style>
